import { useDefaultLandingPageStore, usePromptStore } from '@globalStore/defaultLandingPageStore';
import { useDefaultLandingPageMutation } from '@hooks/useDefaultLandingPage';
import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';
import { useSelector } from 'react-redux';
import { selectedCustomerIdSelector } from '@store/common/selectors';

/**
 * Hook for setting DPI overview as default landing page
 */
export const useDpiDefaultLanding = () => {
  const cid = useSelector(selectedCustomerIdSelector);

  const defaultLandingPage = useDefaultLandingPageStore((state) => ({
    url: state.url,
    name: state.name,
    path: state.path,
  }));

  const { setDefaultLandingPage: mutateLandingPage, isUpdating } = useDefaultLandingPageMutation();
  const { openPrompt, setPromptState } = usePromptStore();

  // Check if current page is already the default landing page
  const { pathname } = window.location;
  const defaultPathname = defaultLandingPage.path || '';
  const isDefaultLandingPage = defaultPathname.endsWith(pathname);

  const handleSetDefaultLanding = () => {
    const { pathname } = window.location;
    const hasDefaultLandingPage = defaultLandingPage.url.length > 0;

    const content = hasDefaultLandingPage
      ? 'Are you sure you want to change your default dashboard?'
      : 'Are you sure you want to set your default dashboard?';

    const obj = {
      title: 'Make default',
      content,
      okFn: () => {
        const url = getActualShareLink(pathname, cid);
        const pageName = pathname.split('/').pop() || 'Overview';

        mutateLandingPage({
          url,
          name: `${pageName}`,
          path: pathname,
        });
      },
      needInput: false,
    };

    setPromptState({
      promptNeedInput: obj.needInput,
      promptTitle: obj.title,
      promptContent: obj.content,
      promptOkFn: obj.okFn,
    });
    openPrompt();
  };

  return {
    handleSetDefaultLanding,
    isSettingDefault: isUpdating,
    isDefaultLandingPage,
  };
};
